import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";

const AgeGate = ({ children }) => {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    setConfirmed(localStorage.getItem("hush_age_ok") === "1");
  }, []);

  const accept = () => {
    localStorage.setItem("hush_age_ok", "1");
    setConfirmed(true);
  };

  if (confirmed) return children;

  return (
    <div
      data-testid="age-gate-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-stone-950"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none"
           style={{ backgroundImage: "radial-gradient(ellipse at top, rgba(136,19,55,0.35), transparent 60%)" }} />
      <div className="relative max-w-lg w-[90%] p-10 md:p-14 border border-stone-800 bg-stone-950/80 backdrop-blur-sm fade-up">
        <div className="overline text-xs font-sans-ui uppercase tracking-[0.3em] text-stone-500 mb-8 text-center">
          INKWELL &mdash; A PRIVATE STUDY
        </div>
        <h1 className="font-serif-heading text-4xl md:text-5xl font-light text-stone-100 text-center leading-tight">
          You must be eighteen<br/>or older to enter.
        </h1>
        <div className="divider-ornament my-10 text-xs">&#10042;</div>
        <p className="text-sm font-sans-ui text-stone-400 text-center leading-relaxed mb-10">
          This is a sanctuary for adult literary fiction &mdash; sensual, explicit, unafraid.
          All characters depicted are adults; all interactions are consensual.
          By entering you confirm you are of legal age in your jurisdiction.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            data-testid="age-gate-accept-btn"
            onClick={accept}
            className="w-full bg-rose-900 hover:bg-rose-800 text-rose-50 rounded-none h-12 font-sans-ui tracking-wider uppercase text-xs"
          >
            I am eighteen or older &mdash; enter
          </Button>
          <a
            href="https://www.google.com"
            data-testid="age-gate-decline-btn"
            className="text-center text-xs font-sans-ui uppercase tracking-[0.2em] text-stone-500 hover:text-stone-300 py-2 transition"
          >
            Leave quietly
          </a>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
